import FeaturesCardStyleWrapper from "./featuresCard.style";

const FeaturesCard = ({ img, title, description }) => {
  return (
    <FeaturesCardStyleWrapper>
      <div className="features_card">
        <div className="features_img">
          <span>{img}</span>
        </div>
        <h3>{title}</h3>
        <h4>{description}</h4>
      </div>
    </FeaturesCardStyleWrapper>
  );
};

export default FeaturesCard;
